import { render, staticRenderFns } from "./MainDepartment.vue?vue&type=template&id=32ec4655&scoped=true"
import script from "./MainDepartment.vue?vue&type=script&lang=js"
export * from "./MainDepartment.vue?vue&type=script&lang=js"
import style0 from "./MainDepartment.vue?vue&type=style&index=0&id=32ec4655&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "32ec4655",
  null
  
)

export default component.exports